// src/services/perfilApi.js
// Llamadas al backend para perfil propio del usuario y carnet.

import { getToken } from './authApi';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5246';

async function authFetch(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || 'Error'), { data, status: res.status });
  return data;
}

async function authUpload(path, formData) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || 'Error'), { data, status: res.status });
  return data;
}

// ── Perfil propio ──────────────────────────────────────────────────────

export const getMiPerfil = () =>
  authFetch('/api/ecolab/usuario/mi-perfil');

export const actualizarMiPerfil = (dto) =>
  authFetch('/api/ecolab/usuario/mi-perfil', {
    method: 'PUT',
    body: JSON.stringify(dto),
  });

export const subirMiFoto = (file) => {
  const fd = new FormData();
  fd.append('archivo', file);
  return authUpload('/api/ecolab/usuario/mi-foto', fd);
};

export const eliminarMiFoto = () =>
  authFetch('/api/ecolab/usuario/mi-foto', { method: 'DELETE' });

export const cambiarMiPassword = (passwordActual, passwordNueva) =>
  authFetch('/api/ecolab/usuario/mi-password', {
    method: 'PUT',
    body: JSON.stringify({ passwordActual, passwordNueva }),
  });

// ── Carnet ─────────────────────────────────────────────────────────────

export const getMiCarnet = () =>
  authFetch('/api/ecolab/carnet/mi-carnet');

// Pública (sin token)
export const validarCarnet = async (codigo) => {
  const res = await fetch(`${BASE}/api/ecolab/carnet/validar/${encodeURIComponent(codigo)}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || 'Error'), { data, status: res.status });
  return data;
};

// Admin: generar carnet de un usuario
export const generarCarnetUsuario = (usuarioId, dto = {}) =>
  authFetch(`/api/ecolab/carnet/admin/generar/${usuarioId}`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

// Admin: listar carnets de un usuario
export const listarCarnetsUsuario = (usuarioId) =>
  authFetch(`/api/ecolab/carnet/admin/usuario/${usuarioId}`);

// Admin: carnet ACTIVO de un usuario (formato completo, listo para render)
// cooperativaId opcional: para usuarios multi-cooperativa, indica de cuál cooperativa.
export const getCarnetActivoUsuario = (usuarioId, cooperativaId) => {
  const qs = cooperativaId ? `?cooperativaId=${cooperativaId}` : '';
  return authFetch(`/api/ecolab/carnet/admin/usuario/${usuarioId}/activo${qs}`);
};

// Admin: cambiar estado de un carnet
export const cambiarEstadoCarnet = (carnetId, estado, motivo) =>
  authFetch(`/api/ecolab/carnet/admin/${carnetId}/estado`, {
    method: 'PUT',
    body: JSON.stringify({ estado, motivo }),
  });

// Admin: foto de usuario
export const subirFotoUsuario = (usuarioId, file) => {
  const fd = new FormData();
  fd.append('archivo', file);
  return authUpload(`/api/ecolab/admin/usuarios/${usuarioId}/foto`, fd);
};

export const eliminarFotoUsuario = (usuarioId) =>
  authFetch(`/api/ecolab/admin/usuarios/${usuarioId}/foto`, { method: 'DELETE' });
